'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosTennisballOutline = function IoIosTennisballOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm36 20v0.6c0 0.4 0 0.9-0.1 1.3-0.8 7.6-7 13.6-14.6 14.3h-0.5s0 0.1-0.1 0.1h-0.9c-9 0-16.3-7.3-16.3-16.3s7.3-16.2 16.3-16.2 16.2 7.2 16.2 16.2z m-1.3 0c0-8.2-6.7-14.9-15-14.9-0.2 0-0.3 0.1-0.6 0.1 0.1 1.8 0.5 3.6 1.2 5.3 0.8 2 2 3.8 3.6 5.4s3.4 2.8 5.4 3.6c1.7 0.7 3.4 1 5.3 1.1 0-0.2 0.1-0.4 0.1-0.6z m-29.9 0c0 8.2 6.7 14.9 15 14.9h0.3c-0.1-1.7-0.6-3.5-1.2-5.1-0.8-2.1-2-3.8-3.6-5.3s-3.3-2.9-5.3-3.6c-1.7-0.7-3.5-1.1-5.2-1.2v0.3z m16.5 14.8c6.9-0.7 12.4-6 13.2-12.9-4.2-0.3-8.3-2-11.5-5.2s-4.9-7.2-5.1-11.5c-6.9 0.9-12.3 6.4-13 13.2 4.1 0.3 8.2 2 11.3 5.1s4.9 7.2 5.1 11.3z' })
        )
    );
};

exports.default = IoIosTennisballOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-tennisball-outline.js
// module id = 2533
// module chunks = 0